import { call, put, spawn, take, select } from 'redux-saga/effects';
import { Record } from 'immutable';
import { createSelector } from 'reselect';
import { appName } from '../config';
import api from '../services/favorites-service';

import { SET_USER_TO_FAVORITE, DELETE_USER_FROM_FAVORITE, isFavoriteUserSelector } from './thread-page';

/**
 * Constants
 */
export const moduleName = 'author-favorite';
export const prefix = `${appName}/${moduleName}`;

export const ADD_REMOVE_FAVORITE_REQUEST = `${prefix}/ADD_REMOVE_FAVORITE_REQUEST`;

export const ADD_TO_FAVORITE_SUCCESS = `${prefix}/ADD_TO_FAVORITE_SUCCESS`;
export const ADD_TO_FAVORITE_FAIL = `${prefix}/ADD_TO_FAVORITE_FAIL`;

export const REMOVE_FROM_FAVORITE_SUCCESS = `${prefix}/REMOVE_FROM_FAVORITE_SUCCESS`;
export const REMOVE_FROM_FAVORITE_FAIL = `${prefix}/REMOVE_FROM_FAVORITE_FAIL`;

// constants for all favorite types (author, alert, category, thread)
export const FAVORITE_RESET_TO_DEFAULT = 'FAVORITE_RESET_TO_DEFAULT';
export const FAVORITE_STATE_CLEAN_UP = 'FAVORITE_STATE_CLEAN_UP';  // saved loading state for link spinner

/**
 * Reducer
 */

export const ProcessRecord = Record({
  done: false,
  err: null
})

export const ReducerRecord = Record({
  loading: false,
  added: ProcessRecord(),
  removed: ProcessRecord()
})

export default function reducer(state = ReducerRecord(), { type, _, err }) {
  switch(type) {
    case ADD_REMOVE_FAVORITE_REQUEST:
      return state.set('loading', true);

    case ADD_TO_FAVORITE_SUCCESS:
      return state.set('loading', false)
                  .set('removed', ProcessRecord())
                  .set('added', ProcessRecord({ done: true }))


    case ADD_TO_FAVORITE_FAIL:
      return state.set('loading', false)
                  .set('removed', ProcessRecord())
                  .set('added', ProcessRecord({ err }))

    case REMOVE_FROM_FAVORITE_SUCCESS:
        return state.set('loading', false)
                    .set('removed', ProcessRecord({ done: true }))
                    .set('added', ProcessRecord())
  
    case REMOVE_FROM_FAVORITE_FAIL:
        return state.set('loading', false)
                    .set('removed', ProcessRecord({ err }))
                    .set('added', ProcessRecord())

    case FAVORITE_STATE_CLEAN_UP:
        return state  
                .set('removed', ProcessRecord())
                .set('added', ProcessRecord())
                
    case FAVORITE_RESET_TO_DEFAULT:
      return state.clear()
            
    default:
      return state;
  }
}
 
 /**
  * Actions
  */
export const addRemoveAuthorFavorite = (userId) => ({ type: ADD_REMOVE_FAVORITE_REQUEST, payload: userId })
export const resetAuthorFavoriteState = () => ({ type: FAVORITE_RESET_TO_DEFAULT })


/**
 * Selectors
 */

export const stateSelector = state => state[moduleName];
export const loadingAuthorSelector = createSelector(
  stateSelector, state => state.loading
);

export const addedAuthorSuccessSelector = createSelector(
  stateSelector, state => state.added.done
)

export const addedAuthorFailSelector = createSelector(
  stateSelector, state => state.added.err
)


export const removedAuthorSuccessSelector = createSelector(
  stateSelector, state => state.removed.done
)

export const removedAuthorFailSelector = createSelector(
  stateSelector, state => state.removed.err
)



/**
* Sagas
*/


const addAuthorToFavoriteSaga = function* (userId) {
  try { 
    yield call(api.addFavoritesAuthor, userId);
    yield put({ type: ADD_TO_FAVORITE_SUCCESS });
    yield put({ type: SET_USER_TO_FAVORITE });
  } catch(err) {
    yield put({ type: ADD_TO_FAVORITE_FAIL, err })
  }
}
const removeAuthorFromFavoriteSaga = function* (userId) {
  try { 
    yield call(api.deleteFavoritesAuthor, userId);
    yield put({ type: REMOVE_FROM_FAVORITE_SUCCESS });
    yield put({ type: DELETE_USER_FROM_FAVORITE });
  } catch(err) {
    yield put({ type: REMOVE_FROM_FAVORITE_FAIL, err })
  }
}


export const addRemoveAuthorSaga = function* () {
  while(true) {
    const { payload: userId } = yield take(ADD_REMOVE_FAVORITE_REQUEST);
    yield put({ type: FAVORITE_STATE_CLEAN_UP }); // close-clean all notice favorites

    const isFavorite = yield select(isFavoriteUserSelector);
    
    if (isFavorite) yield call(removeAuthorFromFavoriteSaga, userId)
    else yield call(addAuthorToFavoriteSaga, userId)
  }
}


export const saga = function* () {
  yield spawn(addRemoveAuthorSaga)
}